"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function momentToDayOfWeek(day) {
    const dow = day.day();
    switch (dow) {
        case 0: {
            return "zondag";
        }
        case 1: {
            return "maandag";
        }
        case 2: {
            return "dinsdag";
        }
        case 3: {
            return "woensdag";
        }
        case 4: {
            return "donderdag";
        }
        case 5: {
            return "vrijdag";
        }
        case 6: {
            return "zaterdag";
        }
        default: {
            throw Error();
        }
    }
}
exports.momentToDayOfWeek = momentToDayOfWeek;
function momentToMonth(day) {
    const dow = day.month();
    switch (dow) {
        case 0: {
            return "januari";
        }
        case 1: {
            return "februari";
        }
        case 2: {
            return "maart";
        }
        case 3: {
            return "april";
        }
        case 4: {
            return "mei";
        }
        case 5: {
            return "juni";
        }
        case 6: {
            return "juli";
        }
        case 7: {
            return "augustus";
        }
        case 8: {
            return "september";
        }
        case 9: {
            return "oktober";
        }
        case 10: {
            return "november";
        }
        case 11: {
            return "december";
        }
        default: {
            throw Error();
        }
    }
}
exports.momentToMonth = momentToMonth;
//# sourceMappingURL=helper.js.map